<whitelist-card (onSubmit)="onWhiteListFormSubmit($event)"></whitelist-card>
<blacklist-card (onSubmit)="onBlackListFormSubmit($event)"></blacklist-card>
